<template>
  <div class="hexCalc">
    <h2>计算传感器ID</h2>
    <el-form :inline="true" :model="form">
      <el-form-item label="请输入ID:">
        <el-input v-model="form.id" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">
          计算
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="onPlus">
          加一
        </el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="onMinus">
          减一
        </el-button>
      </el-form-item>
    </el-form>
    <el-form :inline="true">
      <el-form-item label="groupId:">
        <span style="font-size:30px;" v-text="groupId" />
      </el-form-item>
      <el-form-item label="slaveId:">
        <span style="font-size:30px;" v-text="slaveId" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'HexCalc',
  data() {
    return {
      form: {
        id: ''
      },
      groupId: '',
      slaveId: '',
      hexValue: ''
    }
  },
  mounted() {

  },
  methods: {
    onSubmit() {
      this.calcHex()
    },
    onPlus() {
      this.form.id = parseInt(this.form.id) + 1
      this.calcHex()
    },
    onMinus() {
      this.form.id = parseInt(this.form.id) - 1
      this.calcHex()
    },
    calcHex() {
      this.hexValue = this.PrefixInteger(parseInt(this.form.id, 10).toString(16), 4)
      this.groupId = parseInt(this.hexValue.substring(0, 2).toUpperCase(), 16)
      this.slaveId = parseInt(this.hexValue.substring(2).toUpperCase(), 16)
    },
    PrefixInteger(num, length) {
      return (Array(length).join('0') + num).slice(-length)
    }
  }
}
</script>
